import { Addresses } from "../../commercelayer/vo/addresses";
import { ShippingMethods } from "../../commercelayer/vo/shippingMethods";
import { PaymentMethods } from "../../commercelayer/vo/paymentMethods";
import i18next from "i18next";

export const useOrderVerification = (
  isOrderUpdating: boolean,
  shippingAddress: Addresses | null,
  billingAddress: Addresses | null,
  shippingMethod: ShippingMethods | null,
  paymentMethod: PaymentMethods | null,
) => {
  const errorMessages: string[] = [];

  if (!isOrderUpdating) {
    if (!shippingAddress) {
      errorMessages.push(i18next.t("ORDER VALIDATION ERROR SHIPPING ADDRESS MISSING"));
    }
    if (!billingAddress) {
      errorMessages.push(i18next.t("ORDER VALIDATION ERROR BILLING ADDRESS MISSING"));
    }
    if (!shippingMethod) {
      errorMessages.push(i18next.t("ORDER VALIDATION ERROR SHIPPING METHOD MISSING"));
    }
    if (!paymentMethod) {
      errorMessages.push(i18next.t("ORDER VALIDATION ERROR PAYMENT METHOD MISSING"));
    }
  }

  const isOrderInvalid = !shippingAddress || !billingAddress || !shippingMethod || !paymentMethod;

  return { isOrderInvalid, errorMessages };
};
